import React, { Component } from 'react';
import IobItem from '../../../Domain/IobItem';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import IobService from '../../../Services/IobService';
import IobSearchParams from './IobSearchParams';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditIobWindowDescription from './EditIobWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

class IobAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      orderBy: '',
      orderDirection: OrderDirectionsEnum.Desc,
      shownPanel: IobSearchParams.isThereAnySearchParameter() ? ShownPanelsEnum.Search : ShownPanelsEnum.None,
      searchItem: new IobSearchParams(),
    };

    this.startSearch = this.startSearch.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.getNumberOfSelectedElements = this.getNumberOfSelectedElements.bind(this);
    this.getSelectedElementsList = this.getSelectedElementsList.bind(this);
    this.markMultipleAsPaidFunction = this.markMultipleAsPaidFunction.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    IobItem.editGeneralFunction = this.editGeneralFunction.bind(this);
    IobItem.finalizeFunction = (id) =>
      ErrorMessage.SetWarningWithComment('You are about to finalize an IOB Invoice.', 'Comment', (reason) =>
        this.finalizeFunction(id, reason)
      );
    IobItem.markAsPaidFunction = (id, item) =>
      ErrorMessage.SetWarningWithComment('You are about to mark IOB Invoice as paid.', 'Comment', (reason) =>
        this.markMultipleAsPaidFunction([item], reason)
      );
    IobItem.clickOnSelect = this.clickOnSelect.bind(this);
    IobItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    IobItem.selectedStatus = this.selectedStatus.bind(this);
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    let tempList = [...this.state.itemList];
    if (tempList !== undefined) {
      let tempInstance = tempList.find((c) => c.IobinvoiceId === item.IobinvoiceId);
      if (tempInstance.length !== 0) {
        tempInstance.Selected = selected;

        this.setState({ itemList: tempList });
      }
    }
  }

  selectAllElements() {
    let selectedStatus = false;
    if (this.state.itemList.some((item) => item.Selected === false)) selectedStatus = true;
    let templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  selectedStatus() {
    if (this.state.itemList.some((x) => x.Selected === false)) return false;

    return true;
  }

  startSearch(searchItem) {
    this.setState({ searchItem: searchItem });
  }

  editPanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
    });
  }

  showPanel(panelId) {
    if (panelId === 'MarkAsPaid') {
      ErrorMessage.SetWarningWithComment('You are about to mark IOB Invoices as paid.', 'Comment', (reason) =>
        this.markMultipleAsPaidFunction(this.getSelectedElementsList(), reason)
      );
      return;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  editGeneralFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.Edit,
      selectedItem: item,
    });
  }

  finalizeFunction(id, reason) {
    IobService.FinalizeIobAsync(id, reason)
      .then((result) => {
        if (result.success === false) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Successfully finalized IOB Invoice.');
          this.setState({ searchItem: { ...this.state.searchItem } });
        }
      })
      .catch(() => ErrorMessage.SetErrorMessage('IA210'));
  }

  getFinalizedInvoiceIds(ids) {
    if (ids !== undefined && ids.length > 0) {
      return ids.filter((f) => f.Status === 'Finalized').map((m) => m.IobinvoiceId);
    }
    return [];
  }

  markMultipleAsPaidFunction(ids, reason) {
    const finalized = this.getFinalizedInvoiceIds(ids);

    IobService.MarkMultipleIobsAsPaidAsync(finalized, reason)
      .then((result) => {
        if (result.success === false) {
          ErrorMessage.SetErrorMessage('IA334');
        } else {
          ErrorMessage.SetNotification('Successfully marked as paid.');
          this.setState({ searchItem: { ...this.state.searchItem } });
        }
      })
      .catch(() => ErrorMessage.SetErrorMessage('IA340'));
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Mark as Paid', 'Create']}
          colors={[ButtonColorsEnum.Secondary, ButtonColorsEnum.Primary]}
          keys={['MarkAsPaid', ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-money-bill', 'fa-solid fa-plus-circle']}
          roleKeys={[
            'iob_createcreatelineitemmarkaspaidattachinvoicebutton',
            'iob_createcreatelineitemmarkaspaidattachinvoicebutton',
          ]}
          value={this.state.shownPanel}
          onClick={this.showPanel}
          disabled={[this.getNumberOfSelectedElements() === 0, false]}
        />
        {this.renderPanels()}
      </>
    );
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new IobItem()}
            clickOnCancel={() => this.editPanelOnClose()}
            clickOnSave={() => this.editPanelOnClose()}
            windowDescription={EditIobWindowDescription}
            errorCode='IA167'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Edit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose()}
            clickOnSave={() => this.editPanelOnClose()}
            windowDescription={EditIobWindowDescription}
            errorCode='IA178'
          />
        )}
      </div>
    );
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
    });
  }

  getSelectedElementsList() {
    return this.state.itemList.filter((x) => x.Selected === true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  changeOfItemListFunction(itemList) {
    this.setState({ itemList: itemList });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={IobItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={IobService.GetIobList}
          convertDBItemsFunction={IobService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={this.state.orderBy}
          showSearchStrip={true}
          searchParamsType={IobSearchParams}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in id and status...'
          errorCode='IA238'
        />
      </div>
    );
  }
}

export default IobAdmin;
